import { SET_USER, SIGN_UP, LOGIN_EMAIL } from "../constants/actionTypes";

export const setProfileDetail = user => {
  return {
    type: SET_USER,
    user
  };
};

export const singup = data => {
  return {
    type: SIGN_UP,
    data
  };
};

export const loginEmail = email => {
  return {
    type: LOGIN_EMAIL,
    email
  };
};
